import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectHasDecoration = createSelector(selectJsonQuery, jsonQuery =>
  getTermValue('has_decoration')(jsonQuery),
);
